import { createRouter,createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import('../views/Login.vue')
    }
  },
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Template/Theme/theme_classics.vue'),
    children:[
      {
        path: '/home/about',
        name: 'about',
        meta: {title: '首页', requireLogin: true,index:1},
        component: () => import('../views/About.vue'),
      },
      {
        path: '/home/System/user',
        name: 'user',
        meta: {title: '管理员', requireLogin: true,index:900},
        component: () => import('../views/System/user/index'),
      },
      {
        path: '/home/System/role',
        name: 'role',
        meta: {title: '角色管理', requireLogin: true,index:910},
        component: () => import('../views/System/role/index'),
      },
      {
        path: '/home/System/menu',
        name: 'menu',
        meta: {title: '权限管理', requireLogin: true,index:920},
        component: () => import('../views/System/menu/index'),
      },
      {
        path: '/home/System/branch',
        name: 'branch',
        meta: {title: '部门管理', requireLogin: true,index:930},
        component: () => import('../views/System/branch/index'),
      },
      {
        path: '/home/System/profession',
        name: 'profession',
        meta: {title: '职称管理', requireLogin: true,index:940},
        component: () => import('../views/System/profession/index'),
      },
      {
        path: '/home/System/urbanArea',
        name: 'urbanArea',
        meta: {title: '城市管理', requireLogin: true,index:950},
        component: () => import('../views/Basic/urbanArea/index'),
      },
      {
        path: '/home/article',
        name: 'article',
        meta: {title: '文章管理', requireLogin: true,index:7},
        component: () => import('../views/Basic/article/index'),
      },
      {
        path: '/home/article/type',
        name: 'articleType',
        meta: {title: '文章管理', requireLogin: true,index:8},
        component: () => import('../views/Basic/articleType/index'),
      },
      {
        path: '/home/product',
        name: 'product',
        meta: {title: '商品管理', requireLogin: true,index:201},
        component: () => import('../views/Shop/product/index.vue'),
      },
      {
        path: '/home/product/type',
        name: 'productType',
        meta: {title: '商品分类', requireLogin: true,index:202},
        component: () => import('../views/Shop/productType/index.vue'),
      },
      {
        path: '/home/order',
        name: 'order',
        meta: {title: '订单列表', requireLogin: true,index:300},
        component: () => import('../views/Shop/order/index.vue'),
      },
      {
        path: '/home/order/refund',
        name: 'orderRefund',
        meta: {title: '申请退款', requireLogin: true,index:310},
        component: () => import('../views/Shop/order/refund.vue'),
      },
      {
        path: '/home/serviceOrder/make',
        name: 'OrderMake',
        meta: {title: '预约管理', requireLogin: true,index:320},
        component: () => import('../views/Shop/order/make/order.vue'),
      },
      {
        path: '/home/System/config',
        name: 'config',
        meta: {title: '系统设置', requireLogin: true,index:203},
        component: () => import('../views/System/config/index.vue'),
      },
      {
        path: '/home/ad',
        name: 'ad',
        meta: {title: '广告管理', requireLogin: true,index:101},
        component: () => import('../views/Basic/ad/index.vue'),
      },
      {
        path: '/home/adPlace',
        name: 'adPlace',
        meta: {title: '广告列表', requireLogin: true,index:102},
        component: () => import('../views/Basic/ad/place/index.vue'),
      },
      {
        path: '/home/link',
        name: 'link',
        meta: {title: '友情链接', requireLogin: true,index:103},
        component: () => import('../views/Basic/link/index.vue'),
      },
      {
        path: '/home/nav',
        name: 'place',
        meta: {title: '导航管理', requireLogin: true,index:106},
        component: () => import('../views/Basic/nav/index.vue'),
      },
      {
        path: '/home/System/file',
        name: 'file',
        meta: {title: '文件管理', requireLogin: true,index:107},
        component: () => import('../views/Basic/file/index'),
      },
      {
        path: '/home/Shop/merchant',
        name: 'merchant',
        meta: {title: '门店管理', requireLogin: true,index:501},
        component: () => import('../views/Shop/merchant/index'),
      },
      {
        path: '/home/Shop/merchant/trade',
        name: 'merchantTrade',
        meta: {title: '行业类目', requireLogin: true,index:502},
        component: () => import('../views/Shop/merchant/tradeType/index'),
      },
      {
        path: '/home/Shop/merchant/master',
        name: 'merchantMaster',
        meta: {title: '师傅管理', requireLogin: true,index:502},
        component: () => import('../views/Shop/merchant/master/index.vue'),
      },
      {
        path: '/home/Shop/merchant/apply',
        name: 'merchantApply',
        meta: {title: '申请商户管理', requireLogin: true,index:530},
        component: () => import('../views/Shop/merchant/apply/index.vue'),
      },
      {
        path: '/home/Shop/coupon',
        name: 'coupon',
        meta: {title: '优惠劵管理', requireLogin: true,index:510},
        component: () => import('../views/Shop/coupon/index'),
      },
      {
        path: '/home/Member/member',
        name: 'member',
        meta: {title: '用户管理', requireLogin: true,index:610},
        component: () => import('../views/Member/member/index'),
      },
      {
        path: '/home/Member/level',
        name: 'memberLevel',
        meta: {title: '用户管理', requireLogin: true,index:620},
        component: () => import('../views/Member/level/index'),
      },
      {
        path: '/home/Member/apply',
        name: 'memberApply',
        meta: {title: '申请管理', requireLogin: true,index:630},
        component: () => import('../views/Member/apply/index'),
      },
    ]
  },
  {
    meta: { title: '404' },
    path: '/404',
    name: '404',
    component: () => import('../views/404.vue'),
  },
  {
    path: '/404',
    redirect: '/404',
  },
]

//history模式
const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
